import { AccountCircle } from "@mui/icons-material";
import { Box } from "@mui/system";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { ls } from "../../../variables";
import { Button, styled } from "@mui/material";
import "../styles/topbar.css";
import axios from 'axios';
import { encrypt } from '../../../utils/cipher';

const Dropwdown = ({ isOpen, onClose, handleLogout, open }) => {
  const overlayRef = useRef(null);

  const navigate = useNavigate();

  const userType = ls.get("userType");
  const StyledButton = styled(Button)(() => ({
    ":hover": {
      backgroundColor: "#1F5C8D",
    },
    backgroundColor: "#154063",
    boxShadow:"none !important"
  }));
  // Function to handle click outside of the overlay
  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      onClose(); // Call onClose function passed as prop
    }
  };

  const userManual = async () =>{
    let s3Location = ls.get('userManual');
    const downloadPayload = {
      s3Location: s3Location,
      moduleType: userType,
      downloadType: "userManual",
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    }
    let encryptedPayload = await encrypt(downloadPayload);

    await axios.post('/api/pms/downloadReport',{ payload : encryptedPayload}, {
      withCredentials: true
    }).then((response) => {
      if (response.data.success) {
        window.open(response.data.data, "_self");
      }
    }).catch((error)=>{
      console.log("The required error",error);
    })

  };

  // Add click event listener when the component mounts
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    // Remove click event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div
      ref={overlayRef}
      style={{
        display: "flex",
        width: "10%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <AccountCircle
        sx={{ color: "#FFFFFF", cursor: "pointer" }}
        onClick={isOpen}
      />

      {open && <Box
        className="dropdown"
        sx={{

          width: { xs: "30%", md: "10%" },
          position: "absolute",
          right: { xs: "2rem", md: "4.5rem" },
          backgroundColor: "#ffffff",
          zIndex: "100",
          boxShadow: 6,
          //marginTop: "3rem",
          borderRadius: "0.5rem",
          top: { xs: "5rem", md: "5.5rem", lg: "5.5rem", xl: "7rem" },
          // right:"6.3rem",
          boxShadow: "1px 1px 1px 1px #c5c5c5"
        }
        }
      >
        <div className="logoutBtn" >
        {/* {userType === "SEBI" && 
          <StyledButton
            className="profileButton"
            variant="contained"
            onClick={() => {
              dispatch({ type: "moduleType", moduleType: "GENERAL" });
              navigate('/app/ReportGenModule')
            }}
          >
            General
          </StyledButton>} */}
          <StyledButton
            className="profileButton"
            variant="contained"
            onClick={()=>{userManual()}}
          >
            User Manual
          </StyledButton>
          <StyledButton
            className="profileButton"
            variant="contained"
            onClick={() => {
              const props = { userType: userType }
              navigate("/app/Profile", { state: props })
              onClose()
            }}
          >
            Profile
          </StyledButton>
        </div>
        <div className="logoutBtn" >
          <StyledButton
            className="profileButton"
            variant="contained"
            onClick={handleLogout}
          >
            Log Out
          </StyledButton>
        </div>

      </Box>}
    </div>
  );
};

export default Dropwdown;
